import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './FilterSwitch.css';
// Вспомогательный компонент для раскрытия/закрытия списка категорий
// и стран в мобильной версии.
// В десктопе фильтр всегда раскрыт, а в мобилках по-умолчанию закрыт.
const FilterSwitch = ({ title, setFilterClass }) => {
    const [ isOpen, setIsOpen ] = useState(false);

    const onClick = () => {
        if(isOpen) {
            setFilterClass('filter-hide');
            setIsOpen(false);
        } else {
            setFilterClass('filter-open');
            setIsOpen(true);
        }
    };

    return (
        <div
            className={`FilterSwitch ${isOpen ? 'Open' : ''}`}
            onClick={() => onClick()}
        >
                <span>{title}&nbsp;</span>
                <span className={isOpen ? 'rotate-open' : 'rotate-hide'}>
                    <FontAwesomeIcon icon={faChevronDown}/>
                </span>
        </div>
    );
};

export default FilterSwitch;
